import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { DermMenuComponent } from '../derm-menu/derm-menu.component';
import { MatDialog } from '@angular/material/dialog';
import { DermService } from 'src/app/includes/derm/derm.service';
import { WoundImageUploadDialogComponent } from '../../wound-care-widget/wound-image-upload-dialog/wound-image-upload-dialog.component';
import { WoundImageSnapshotDialogComponent } from '../../wound-care-widget/wound-image-snapshot-dialog/wound-image-snapshot-dialog.component';
import { WoundImagePreviewDialogComponent } from '../../wound-care-widget/wound-image-preview-dialog/wound-image-preview-dialog.component';
import swal from 'sweetalert';
import { ToastrService } from 'ngx-toastr';
import { DermReportViewerComponent } from './derm-report-viewer/derm-report-viewer.component';

@Component({
  selector: 'app-derm-main-widget',
  templateUrl: './derm-main-widget.component.html',
  styleUrls: ['./derm-main-widget.component.css']
})
export class DermMainWidgetComponent implements OnInit {
  @Input() provider;
  @Input() readOnlyMode: any;
  @Input() patient;
  @Input() derm;
  @Input() isPreview;
  @Input() note;
  @Input() dermState;
  @Output() reloadDerms = new EventEmitter<boolean>();

  expanded = false;
  mainImage = "";
  otherImages: any = [];
  childDermsLoaderId = 'childDermsLoaderId' + Math.random();
  expandedView: 'child_derms' | 'graph' | 'wound_images' | '' = '';


  constructor(
    private loader: NgxUiLoaderService,
    private dermService: DermService,
    private dialog: MatDialog,
    private toastr: ToastrService,

    ) { }

  ngOnInit(): void {
    this.mainImage = this.derm.derm_images[0];
    if (this.derm.derm_images.length > 1) {
      this.otherImages = this.derm.derm_images.slice(1)
    }
  }
  showWoundImageSnapshotDialog(){
    const dialogRef = this.dialog.open(WoundImageSnapshotDialogComponent, {
      width: 'auto',
      data: { wound: {...this.derm, wound_images:this.derm.derm_images} }
    });
    dialogRef.afterClosed().subscribe(async (uploadedImages: string[]) => {
      if (Array.isArray(uploadedImages)) {
        this.otherImages = this.otherImages.concat(uploadedImages);
        // this.wound.wound_images = this.wound.wound_images.concat(uploadedImages);
      }
    });
  }
  showWoundImageUploadDialog(){
    const dialogRef = this.dialog.open(WoundImageUploadDialogComponent, {
      width: 'auto',
      data: { wound: {...this.derm, wound_images:this.derm.derm_images} }
    });
    dialogRef.afterClosed().subscribe(async (uploadedImages: string[]) => {
      if (Array.isArray(uploadedImages)) {
        // this.wound.wound_images = this.wound.wound_images.concat(uploadedImages);
        this.otherImages = this.otherImages.concat(uploadedImages);
      }
    });
  }
  isArchivedDerm(){
    return ((this.dermState == "archived"||this.dermState == "submit"||this.dermState == "recieve"));
  }
  async handleDermClick($event, derm){

    console.log('handleWoundClick')
    if (!this.isClickAllowed($event.target)) return;
    this.showDermEditDialog(derm);
  }
  toggleShowAllImages() {
    if (this.expandedView === 'wound_images') {
      this.toggleExpand();
    } else {
      this.expand();
      this.expandedView = 'wound_images';
    }
    // this.showAllImages = !this.showAllImages
  }
  isClickAllowed($element){
    const { classList, tagName } = $element;
    console.log({ classList, tagName, $element })
    const tagNames = ['button', 'mat-icon'];
    const classNames = ['mat-button-wrapper'];
    if (tagNames.includes(tagName.toLowerCase())) return false;
    if (classNames.some(className => classList.contains(className))) return false;
    return true;
  }
  showDermEditDialog(latest_derm){
    console.log("this.childWound", latest_derm, this.derm);
    const dialogRef = this.dialog.open(DermMenuComponent, {
      maxWidth: '100vw',
      width: '75%',
      data: {
        provider: this.provider,
        patient: this.patient,
        main_derm: this.derm,
        latest_derm
      }
    });
    dialogRef.afterClosed().subscribe(async (updatedDerm: any) => {
      if (updatedDerm) {
        console.log("updatedDerm", updatedDerm);
        if (updatedDerm) {
            const resp:any = await this.dermService.updateDermComplaint(this.derm._id,updatedDerm).toPromise();
            if(resp.status == 200){
              this.toastr.success('Derm Case updated successfully', 'Success');
              this.reloadDermsAtParentPage();
            }else{
              this.toastr.error('Derm Case failed to update.', 'Error');
            }
        }
      }
    });
  }
  showWoundImagePreviewDialog(derm, imageIndex = 0) {
    const dialogRef = this.dialog.open(WoundImagePreviewDialogComponent, {
      width: 'auto',
      data: { wound: {...derm, wound_images:derm.derm_images}, imageIndex: imageIndex }
    });
  }
  hasChildDerms(){
      return false
  }

  async getDermConsultation(){

    this.loader.startLoader(this.childDermsLoaderId);
      const resp:any = await this.dermService.getDermConsultation(this.derm._id).toPromise();
      this.loader.stopLoader(this.childDermsLoaderId);
      if(resp.status == 200){
        this.toastr.success('Derm consultation fetched successfully', 'Success');
        console.log("resp", resp.data);
        this.reloadDermsAtParentPage();
        const dialogRef = this.dialog.open(DermReportViewerComponent, {
          width: 'auto',
          data: resp?.data,
          height: '73vh'
        });
      }else{
        this.toastr.error(resp.message||'Derm consultation failed to fetch.', 'Error');
      }
  }

  getDate(date_obj){
    if(!date_obj) return '---';
    let month = date_obj.month;
    let day = date_obj.day;
    if(date_obj.month<=9){
      month = '0'+date_obj.month;
    }
    if(date_obj.day<=9){
      day = '0'+date_obj.day;
    }
    return (month+'-'+day+'-'+date_obj.year);
  }
  toggleChildDerm() {
    if (this.expandedView === 'child_derms') {
      this.toggleExpand();
    } else {
      this.expand();
      this.expandedView = 'child_derms';
    }
  }
  toggleExpand() {
    this.expanded = !this.expanded
  }
  expand() {
    this.expanded = true;
  }

  submitDermForReview(derm){
    if(!derm._id) return;

    swal({
      title: "Are you sure to submit?",
      text: "Once submitted, the derm will be sent for review and can't be edited.",
      icon: "warning",
      dangerMode: true,
    }).then((willSubmit) => {
      if (!willSubmit) return;
      
      this.loader.startLoader(this.childDermsLoaderId);
      const date_obj = {
        month: new Date().getMonth() + 1,
        day: new Date().getDate(),
        year: new Date().getFullYear()
      };
      this.dermService.submitDermForReview(derm._id, date_obj).subscribe(
        (resp: any) => {
          if(resp.status == 200){
            this.toastr.success('Derm Case Submitted successfully', 'Success');
            this.reloadDermsAtParentPage();
          }else{
            this.toastr.error(resp.message||'Derm Case failed to submit.', 'Error');
          }
          this.loader.stopLoader(this.childDermsLoaderId);
        })
    });
    

  }

  reloadDermsAtParentPage(){
    this.reloadDerms.emit(true);
  }

}
